const ItemSvg: React.FC = () => {
  return (
    <svg
      width="18"
      height="22"
      viewBox="0 0 18 22"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M4.5 10.7422H13.5C13.6031 10.7422 13.6875 10.6578 13.6875 10.5547V9.42969C13.6875 9.32656 13.6031 9.24219 13.5 9.24219H4.5C4.39688 9.24219 4.3125 9.32656 4.3125 9.42969V10.5547C4.3125 10.6578 4.39688 10.7422 4.5 10.7422Z"
        fill="#0033C6"
      />
      <path
        d="M16.5 0.5H1.5C1.08516 0.5 0.75 0.835156 0.75 1.25V20.75C0.75 21.1648 1.08516 21.5 1.5 21.5H16.5C16.9148 21.5 17.25 21.1648 17.25 20.75V1.25C17.25 0.835156 16.9148 0.5 16.5 0.5ZM15.5625 19.8125H2.4375V15.1016H4.73203C5.00391 15.8703 5.48203 16.5617 6.11719 17.0867C6.92578 17.7547 7.95 18.125 9 18.125C10.05 18.125 11.0742 17.757 11.8828 17.0867C12.518 16.5617 12.9961 15.8703 13.268 15.1016H15.5625V19.8125ZM15.5625 13.625H12.0844L11.9625 14.2039C11.6813 15.6055 10.4344 16.625 9 16.625C7.56563 16.625 6.31875 15.6055 6.03516 14.2039L5.91328 13.625H2.4375V2.1875H15.5625V13.625Z"
        fill="#0033C6"
      />
      <path
        d="M4.5 6.99219H13.5C13.6031 6.99219 13.6875 6.90781 13.6875 6.80469V5.67969C13.6875 5.57656 13.6031 5.49219 13.5 5.49219H4.5C4.39688 5.49219 4.3125 5.57656 4.3125 5.67969V6.80469C4.3125 6.90781 4.39688 6.99219 4.5 6.99219Z"
        fill="#0033C6"
      />
    </svg>
  );
};

export default ItemSvg;
